'use client';

import { useState, useEffect } from 'react';

/**
 * Animated Shoosh wordmark — alternates between clean and messy frames
 * at ~3fps for a hand-drawn wobble effect.
 */
export default function ShooshLogo({ className = '', height = 32 }) {
  const [frame, setFrame] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setFrame((f) => (f === 0 ? 1 : 0));
    }, 300); // ~3fps
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`relative ${className}`} style={{ height }}>
      <img
        src="/logo/shoosh-1.png"
        alt="Shoosh"
        className="h-full w-auto"
        style={{ display: frame === 0 ? 'block' : 'none' }}
        draggable={false}
      />
      <img
        src="/logo/shoosh-2.png"
        alt="Shoosh"
        className="h-full w-auto"
        style={{ display: frame === 1 ? 'block' : 'none' }}
        draggable={false}
      />
    </div>
  );
}
